import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <circle
        cx="188"
        cy="172"
        r="24"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M157 220a32 32 0 0162 0M120 208H40a8 8 0 01-8-8V64a8 8 0 018-8h53.3a8.1 8.1 0 014.8 1.6l27.8 20.8a8.1 8.1 0 004.8 1.6H216a8 8 0 018 8v32"
      />
    </svg>
  );
}

export default Icon;
